export {
  Add as AddIcon,
  Remove as RemoveIcon,
  ArrowBackIos as BackIcon,
  MoreVert as MoreIcon,
  Sort as SortIcon,
  ArrowBack as PrevIcon,
  ArrowForward as NextIcon,
  ExpandMore as ExpandIcon,  
  ArrowDropDown as DropDownIcon,
  Close as CloseIcon,
  Clear as ClearIcon,
  Send as SendIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Clear as CancelIcon,
  Save as SaveIcon,
  Done as DoneIcon,
  AddAPhoto as AddPhotoIcon,
  DirectionsRun as RunIcon,
  LocalOffer as ProductIcon,  
  Email as EmailIcon,
  Comment as CommentIcon,
  ContactSupportOutlined as SupportIcon,  
  BugReport as BugIcon,
  Share as ShareIcon,
  Person as PersonIcon,
  Cancel as CancelAltIcon,
  Payment as PaymentIcon,
  Print as PrintIcon,
  Label as LabelIcon,
  ShoppingBasket as CartIcon,
  ChevronRightRounded as ArrowRightIcon,
  AddShoppingCart as ATCIcon,
  Chat as ConversationIcon,
  HourglassEmpty as PendingIcon,
  Block as BlockIcon,
  Markunread as MarkUnreadIcon,
  PanoramaSharp as ImageLandscapeIcon,
  FileCopy as DuplicateIcon
} from '@material-ui/icons'
